import React, { useEffect, useMemo, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_ColumnDef,
} from 'material-react-table';
// import Image from 'mui-image';
import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from 'src/components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';
import { Course } from 'src/types/course/course';
import axiosServices from 'src/utils/axios';
import { AxiosResponse } from 'axios';
import // IconButton,
    // MenuItem
    '@mui/material';

import {
    //  closeSnackbar,
    useSnackbar,
} from 'notistack';
import Spinner from 'src/views/spinner/Spinner';
import { Button } from '@mui/material';


const BCrumb = [
    {
        to: '/',
        title: 'Home',
    },
    {
        title: 'Session',
    },
];

const Session = () => {

    const { enqueueSnackbar } = useSnackbar();
    const [RequestCourse, setRequestCourse] = useState<Course[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [Loader, setLoader] = useState<boolean>(false);

    const columns = useMemo<MRT_ColumnDef<Course>[]>(
        () => [
            {
                accessorKey: 'id', //access nested data with dot notation
                header: 'id',
                size: 100,
            },
            {
                accessorKey: 'course_name',
                header: 'name',
                size: 150,
            },
            {
                accessorKey: 'course_price', //normal accessorKey
                header: 'price',
                size: 100,
            },
            {
                accessorKey: 'user_name', //normal accessorKey
                header: 'Student',
                size: 200,
            },
            {
                accessorKey: 'status', //normal accessorKey
                header: 'Request',
                size: 150,
            },

            {
                accessorKey: 'Session Status', //normal accessorKey
                header: 'Session Status',
                Cell: ({ row }) => (
                    // eslint-disable-next-line react/jsx-no-undef
                    <Button variant="contained" color="primary">{row.original.status === 'Approved' ? 'Started' : row.original.status === 'Complete' ? 'Complete' : 'Not Started'}</Button>
                ),

                size: 200,
            },
            {
                accessorKey: 'Session Complete', //normal accessorKey
                header: 'Session Complete',
                Cell: ({ row }) => (
                    // eslint-disable-next-line react/jsx-no-undef
                    row.original.status === 'Approved' ?
                        <button className="session-status" onClick={() => handleRequest('Complete', row.original.id)}>{Loader ? '...' : 'Press For Completed'}</button>
                        :
                        row.original.status === 'Complete' ?
                            <button className='lab-btn' > Completed</button>
                            :
                            <button className='lab-btn' > Not Started</button>

                ),

                size: 200,
            },

        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: RequestCourse,
        state: { isLoading: loading },
        enableRowActions: false,
    });

    const getAllCourse = async () => {
        setLoading(true);
        try {
            const response: AxiosResponse = await axiosServices.get(`/teacher/course/request/view`);
            console.log(response, "response")
            setRequestCourse(response.data.data);
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            if (error.response) {
                // This is an Axios error with a response object
                enqueueSnackbar(error.response.data.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            } else {
                // This is a general error
                enqueueSnackbar(error.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            }
        }
    };

    useEffect(() => {
        getAllCourse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRequest = async (value: any, id: any) => {
        setLoader(true);
        try {
          const formData = new FormData();
          formData.append('status', value);
          const response: AxiosResponse = await axiosServices.post(`/teacher/course/status/update/${id}`, formData);
          enqueueSnackbar(response?.data.message, { variant: 'success' });
          getAllCourse();
          setLoader(false);
        } catch (error: any) {
            setLoader(false);
          if (error.response) {
            // This is an Axios error with a response object
            enqueueSnackbar(error.response.data.message, { variant: 'error' });
          } else {
            // This is a general error
            enqueueSnackbar(error.message, { variant: 'error' });
          }
        }
      };


    if (loading) {
        return <Spinner />;
    }

    return (
        <PageContainer title="All Session " description="All Session">
            {/* breadcrumb */}
            <Breadcrumb title="Session" items={BCrumb} />
            <BlankCard>
                {/* ------------------------------------------- */}
                {/* Left part */}
                {/* ------------------------------------------- */}

                <MaterialReactTable table={table} />
            </BlankCard>
        </PageContainer>
    );
};

export default Session;

